import path from 'path';
import { combineEpics } from 'redux-observable';
import { ignoreElements, mergeMap } from 'rxjs/operators';
import { EpicType } from './common';

import {
	LOCATION_CHANGE,
	LocationChangeAction,
	RouterLocation,
} from 'connected-react-router';

import Config from '../site.config.json';

/**
 * base values for manifest
 */
const manifestBase = {
	background_color: '#2564bf',
	description: 'Generalist/LM for e-Learning Management',
	display: 'standalone',
	icons: [
		{
			purpose: 'any',
			sizes: '16x16',
			src: 'icons/favicon.ico',
			type: 'image/x-icon',
		},
	],
	name: 'Generalist/LM',
	short_name: 'Generalist/LM',
	theme_color: '#2564bf',
};

/**
 * change manifest json
 * @param location router location
 */
const changeManifest = async ({ pathname }: RouterLocation<unknown>) => {
	const [, appName, conpanyCode] = pathname.split('/');
	const scope = path.join(
		...[
			window.location.origin,
			appName,
			...(Config.multiTenant ? [conpanyCode] : []),
		]
	);
	const url = path.join(scope, 'login');

	const manifest = {
		...manifestBase,
		icons: manifestBase.icons.map(({ src, ...rest }) => ({
			...rest,
			src: `/${path.join(appName, src)}`,
		})),
		scope,
		start_url: url,
	};

	const stringManifest = JSON.stringify(manifest);
	const blob = new Blob([stringManifest], { type: 'application/json' });
	const manifestURL = URL.createObjectURL(blob);

	const manifestDom = document.querySelector('#manifest');
	if (manifestDom) {
		manifestDom.setAttribute('href', manifestURL);
	} else {
		console.warn('manifest not set');
	}
};

/**
 * set manifest on location change
 * @param action$ action observable
 */
const dynamicManifestEpic: EpicType = action$ =>
	action$.ofType(LOCATION_CHANGE).pipe(
		mergeMap(({ payload: { location } }: LocationChangeAction) =>
			changeManifest(location)
		),
		ignoreElements()
	);

/**
 * events on routing
 */
export const routerEpic = combineEpics(dynamicManifestEpic);



// WEBPACK FOOTER //
// ./src/epics/router.ts